<template>
  <el-dialog v-dialogDrag :title="'工时统计'" :visible.sync="panel" :before-close="closeDialog"
    :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
    <el-tabs v-model="activeTab" class="tabs" @tab-click="handleTabClick">
      <el-tab-pane :label="tabs[0].label" :name="tabs[0].name">
        <el-table :data="detailData" style="width: 100%; height: 400px; overflow: auto" border>
          <el-table-column prop="operUserName" label="姓名" show-overflow-tooltip></el-table-column>
          <el-table-column prop="itemName" label="项目" show-overflow-tooltip></el-table-column>
          <el-table-column prop="specName" label="专业" width="100"></el-table-column>
          <el-table-column prop="roleName" label="角色" width="120"></el-table-column>
          <el-table-column prop="openTime" label="任务时间" width="100"></el-table-column>
          <el-table-column prop="workTime" label="任务时长（小时）" width="150"></el-table-column>
          <el-table-column prop="commitTime" label="提交时间" width="100"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="tabs[1].label" :name="tabs[1].name">
        <el-table :data="secondDetailData" style="width: 100% ;height: 400px; overflow: auto" border>
          <el-table-column prop="userName" label="姓名" show-overflow-tooltip></el-table-column>
          <el-table-column prop="prjName" label="项目" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="specName" label="专业" width="120"></el-table-column>
          <el-table-column prop="roleName" label="角色" width="100"></el-table-column>
          <el-table-column prop="operateTime" label="记录时间" width="140"></el-table-column>
          <el-table-column prop="typeName" label="类型" width="100"></el-table-column>
          <el-table-column prop="lastMinute" label="时长（分钟）" width="120"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>
<script>
import request from "@/CommonDP/service/sysServer-service";
export default {
  props: {
    listQuery: {
      type: Object,
      default: () => {}
    },
    userInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      panel: false,
      username: "",
      detailData: [],
      secondDetailData: [],
      activeTab: "first", // 默认的活动tab
      tabs: [
        {
          id: 1,
          label: "填报记录详情",
          name: "first"
        },
        {
          id: 2,
          label: "自动记录详情",
          name: "second"
        }
      ]
    };
  },
  watch: {
    userInfo: {
      handler: function () {
        this.handleTabClick();
      }
    }
  },
  methods: {
    closeDialog() {
      this.panel = false;
    },
    showDialog() {
      this.panel = true;
    },
    async getData() {
      var { userID } = this.userInfo;
      var params = {
        startDate: this.listQuery.startDate,
        endDate: this.listQuery.endDate,
        operUserID: userID
      };
      var res = await request.countDetail(params);
      if (res.result == "0") {
        this.detailData = res.data;
      }
    },
    async getSecondTableData() {
      var { userID } = this.userInfo;
      var res = await request.autoReportDetail(userID);
      if (res.result == "0") {
        this.secondDetailData = res.data;
      }
    },
    showpanel(bool, val, data) {
      this.username = val;
      this.panel = bool;
      this.detailData = data;
    },
    handleTabClick() {
      if (this.activeTab == "second") {
        this.getSecondTableData();
      } else if (this.activeTab == "first") {
        this.getData();
      }
    }
  }
};
</script>
<style lang="scss" scope="scoped">
.detailmain {
  width: 960px;
  height: 400px;
  position: absolute;
  left: calc(50% - 480px);
  top: calc(50% - 260px);
  border-left: 1px solid #aaaaaa;
  border-right: 1px solid #aaaaaa;
  border-bottom: 1px solid #aaaaaa;
  background: #ffffff;
}
.detailheader {
  width: 960px;
  height: 40px;
  background: #66ccff;
  color: #ffffff;
  padding: 10px;
}
.close {
  cursor: pointer;
  float: right;
}
.detailbody {
  height: 358px;
  overflow-y: auto;
}
.detailbody::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}
.detailbody::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.detailbody::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
</style>
